import React, { useRef, useState, useEffect } from 'react';
import Nav from './Nav';
import Footer from './Footer'; // Assume Footer is another component
import { useLocation, useRoutes } from 'react-router-dom';
import useUser from '../Hooks/useUser';
import BasicCourseAd from '../LandingPageComponents/BasicCourseAd';

const Layout = ({ children, displayNav }) => {
    const location = useLocation()
    const user = useUser();
    const [navHeight, setNavHeight] = useState(0);

    useEffect(() => {
        const updateNavHeight = () => {
            const navElement = document.querySelector('nav');
            if (navElement) {
                setNavHeight(navElement.offsetHeight);
            }
        };

        // Small delay to ensure DOM is fully rendered
        const timer = setTimeout(updateNavHeight, 100);
        window.addEventListener('resize', updateNavHeight);

        return () => {
            clearTimeout(timer);
            window.removeEventListener('resize', updateNavHeight);
        };
    }, []);

    // console.log('Rendering once')
    const navRoutes = ['/', '/contact', '/grammar', '/courses', `/my-progress/${user.userId}`, '/login', "/signup"];
    const excludeNavPage = '/cursodeingles';
    const excludeFooterPages = ['/grammar', '/flashcards', '/vocabulary', '/progress'];
    const isQuizPage = location.pathname.startsWith('/quiz/');
    const shouldExcludeFooterForQuiz = isQuizPage;
    // no need to include nav in login, just make sure progress page has the same background color
    const shouldExcludeNav = location.pathname === excludeNavPage;
    const shouldExcludeFooter = excludeFooterPages.includes(location.pathname);
    return (
        <div className="flex flex-col  overflow-x-hidden z-8">

            {!shouldExcludeNav && <Nav />}
            {!shouldExcludeNav && <BasicCourseAd />}

            <main className='p-0 font-body'>
                {children}
            </main>
            {!shouldExcludeNav && !shouldExcludeFooter && !shouldExcludeFooterForQuiz && <Footer />}

        </div>
    );
}

export default Layout;
